import { render, staticRenderFns } from "./indexTaaxii.vue?vue&type=template&id=7e9cb80e&"
import script from "./indexTaaxii.vue?vue&type=script&lang=ts&"
export * from "./indexTaaxii.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports